import { render, staticRenderFns } from "./AdminCreateView.vue?vue&type=template&id=78ebee6c"
import script from "./AdminCreateView.vue?vue&type=script&lang=js"
export * from "./AdminCreateView.vue?vue&type=script&lang=js"
import style0 from "./AdminCreateView.vue?vue&type=style&index=0&id=78ebee6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports